<template>
  <div class="banner-box">
    <div class="content-box">
      <img class="bg-images" :src="imgURL" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgURL: require('@/assets/pngs/banner-main-prd@2x.png'),
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-box{
  position: relative;
  .content-box{
    width: 100%;
    height: 200px;
    position: relative;
    .bg-images{
      width: 100%;
      background-size: 100%;
      position: absolute;
      width: 100%;
      top: 0px;
      left: 0px;
    }
    .banner-message{
      width: 250px;
      position: absolute;
      top: 60px;
      left: 20px;
      z-index: 2;
      .title-logo{
        width: 100px;
        height: 50px;
      }
      .message{
        font-size: 12px;
        color: #ffffff;
        margin-top: 10px;
        text-align: left;
      }
    }
  }
  ::v-deep .swiper-pagination-bullets{
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    .swiper-pagination-bullet{
      width:6px;
      height:6px;
      background:rgba(255,255,255,1);
      border-radius:3px;
      margin-right: 5px;
      opacity: 1;
      outline: none;
      &.swiper-pagination-bullet-active{
        width:30px;
        height:6px;
        background:rgba(255,255,255,0.5);
        border-radius:3px;
        outline: none;
      }
    }
  }
}
</style>
